/** Set while a confirmed cancel-return is in flight so history.block allows the org redirect. */
let pendingCancelReturnNavigation = false;

export const beginCancelReturnNavigation = (): void => {
  pendingCancelReturnNavigation = true;
};

export const endCancelReturnNavigation = (): void => {
  pendingCancelReturnNavigation = false;
};

export const consumeCancelReturnNavigation = (): boolean => {
  if (!pendingCancelReturnNavigation) {
    return false;
  }
  pendingCancelReturnNavigation = false;
  return true;
};
